import React, { Component } from 'react';
import authService from '../../_services/AuthService';
import UserContext from '../context/UserContext';
import { Link } from 'react-router-dom';

export class ForcedLogout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: 'Logout processing',
            isReady: false,
            loading: true
        };
    }
    componentDidMount() {
        document.title = "CESJoinIN - Logout";        
        const isLoggedIn = authService.loggedIn();
        if (isLoggedIn) {
            if (!this.context.fullState.loading) {
                this.logoutAPI();
            }
            this.setState({
                contextLoading: this.context.fullState.loading,
                forceLogoutMessage: this.context.fullState.forceLogoutMessage
            })
        } else {
            this.setState({ isReady: true, message: "You are already logged out!" });
        }
        this.context.clearContext();
    }

    componentDidUpdate() {
        const isLoggedIn = authService.loggedIn();
        if (this.state.forceLogoutMessage !== this.context.fullState.forceLogoutMessage && this.context.fullState.forceLogoutMessage !== null) {
            this.setState({
                forceLogoutMessage: this.context.fullState.forceLogoutMessage
            })
        }
        if (isLoggedIn) {
            if (this.state.contextLoading === this.context.fullState.loading) {
                if (!this.state.loading) {
                    authService.logout();
                    sessionStorage.clear();
                    this.context.clearContext();
                    this.setState({ isReady: true, message: "You were successfully logged out!" });
                } else {
                    this.logoutAPI();
                }
            } else {
                if (!this.context.fullState.loading) {
                    this.setState({
                        contextLoading: this.context.fullState.loading
                    })
                    this.logoutAPI();
                }
            }
        }

    }


    logoutAPI = async () => {
        try {
            const token = authService.getToken();
            const response = await fetch('VMAttendeeLogout', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                //body: JSON.stringify(request)
            });
            const resdata = await response.json();
            if (resdata) {
                this.setState({
                    loading: false
                })
            }
        } catch {
            this.setState({
                loading: false
            })
        }

    }


    render() {
        const { isReady, message } = this.state;
        
        if (!isReady) {
            return (<div className="">
                <hr />
                <p>You have been removed from the meeting by the administrator</p>
                {!!this.state.forceLogoutMessage ? <p>{this.state.forceLogoutMessage}</p> : ''}
                {message}
            </div>);
        }
        if (!!message) {
            return (
                <div className="">
                    <hr />
                    <p>You have been removed from the meeting by the administrator</p>
                    {!!this.state.forceLogoutMessage ? <p>{this.state.forceLogoutMessage}</p> : ''}
                    {message}
                    <div className="loggedOut">Click <Link to="../../login/">here</Link> to rejoin</div>
                </div>

            );
        }
        return (<div>Logging out....</div>);

    }
}

ForcedLogout.contextType = UserContext;
